<template>
  <div id="rename-modal" class="editor-modal">
    <h3>{{ title }}</h3>
    <!-- <form @submit.stop.prevent> -->
    <form @submit="onRename">
      <custom-input
        :inputType="'text'"
        v-model="newName"
        :name="'nameInput'"
        :label="inputName"
        :placeholder="inputPlaceholder || $t('enter-name')"
        :focusInputField="true"
      />
      <span v-if="nameIsReserved && changes" class="text-danger text-xs">{{ $t("rename.name-reserved") }}</span>
      <div v-if="idChange" class="form-group" style="margin-bottom:0;">
        <checkbox class="checkbox" :label="idLabel" :name="'change-id'" v-model="changeId" />
      </div>

      <div v-if="changeId">
        <custom-input
          :inputType="'text'"
          v-model="newId"
          :name="'id'"
          :label="$t('rename.section-id')"
          :placeholder="'Id'"
          :focusInputField="true"
        />
        <span class="text-danger text-xs">{{ idDesc }}</span>
      </div>

      <div class="footer">
        <button type="submit" class="btn btn-md btn-primary" :disabled="!valid || nameIsReserved" @click="onRename">
          {{ primaryButton }}
        </button>
        <button type="reset" class="btn btn-md btn-secondary" @click="onClose">
          {{ $t("rename.rename-btn-cancel") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import Checkbox from "@/components/Checkbox";
export default {
  props: {
    existingName: String,
    existingId: String,
    onSave: Function,
    inputName: String,
    inputPlaceholder: String,
    title: String,
    allowEmpty: Boolean,
    primaryButton: String,
    idChange: Boolean,
    idLabel: String,
    idDesc: String,
    invalidOptions: Array,
    paragraphCheckbox: Boolean,
    sectionParagraphs: Boolean
  },
  data() {
    return {
      newName: this.existingName || "",
      changeId: false,
      newId: this.existingId,
      changes: false,
      changeParagraph: false
    };
  },
  computed: {
    valid() {
      return this.allowEmpty || (this.newName && this.newName !== this.existingName);
    },
    nameIsReserved() {
      return this.invalidOptions
        ? this.invalidOptions.includes(this.newName) ||
            this.invalidOptions.includes(
              this.newName
                .toLowerCase()
                .replaceAll(/[^\w ]+/g, "")
                .replaceAll(/ +/g, "")
            )
        : false;
    }
  },
  methods: {
    onRename(evt) {
      evt.preventDefault();
      if (this.changeId == true || this.paragraphCheckbox) {
        let data = { name: this.newName };
        if (this.changeId == true) {
          data.idChange = true;
          data.id = this.newId;
        }
        if (this.paragraphCheckbox) {
          data.paragraph = this.changeParagraph;
        }
        this.onSave(data);
      } else {
        this.onSave(this.newName);
      }
      this.$emit("close");
    },
    onClose(evt) {
      this.$emit("close");
    }
  },
  mounted() {
    if (this.paragraphCheckbox) {
      this.changeParagraph = this.sectionParagraphs || false;
    }
  },
  watch: {
    newName: {
      handler: function() {
        this.changes = true;
      }
    }
  },
  components: {
    CustomInput,
    Checkbox
  }
};
</script>

<style lang="less">
#rename-modal {
  padding: 20px;
  h3 {
    margin: 0;
  }
  .footer {
    margin-top: 12px;
  }
  .checkbox-wrapper {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }
  .checkbox {
    margin-top: 12px;
    margin-bottom: 0px;
  }
}
</style>
